export const LOCALE_DEFAULT = 'en-us';

export const LOCALES_RTL = new Set(['he-il']);

export const LANGUAGE_DEFAULT = 'en';

export function isRTL(locale: string): boolean {
    return LOCALES_RTL.has(locale);
}
